import { Component, AfterViewInit, OnInit } from '@angular/core';
import c3 from 'c3';
import {
	NzTablePaginationPosition,
	NzTableSize
} from 'ng-zorro-antd/table/src/table.types';

@Component({
	selector: 'app-hardware-spielwiese',
	templateUrl: './hardware.component.html'
})
export class HardwareSpielwieseComponent implements AfterViewInit, OnInit {
	// Dinge für die Table
	listOfData: any[] = [];
	bordered = false;
	loading = false;
	sizeChanger = false;
	pagination = true;
	header = true;
	title = true;
	footer = true;
	fixHeader = false;
	size: NzTableSize = 'small';
	expandable = true;
	checkbox = true;
	allChecked = false;
	indeterminate = false;
	displayData: any[] = [];
	simple = false;
	noResult = false;
	position: NzTablePaginationPosition = 'bottom';

	button3title: string;

	// für die Plots
	dataGut = [
		'Gut',
		1.4,
		1.5,
		1.5,
		1.3,
		1.5,
		1.3,
		1.6,
		1,
		1.3,
		1.4,
		1,
		1.5,
		1,
		1.4,
		1.3,
		1.4,
		1.5,
		1,
		1.5,
		1.1,
		1.6,
		1.3,
		1.5,
		1.2,
		1.3,
		1.4,
		1.4,
		1.2,
		1.5,
		1,
		1.1,
		1,
		1.2,
		1.6,
		1.5,
		1.6,
		1.5,
		1.3,
		1.3,
		1.3,
		1.2,
		1.4,
		1.2,
		1,
		1.3,
		1.2,
		1.3,
		1.3,
		1.1,
		1.3
	];
	dataOMG = [
		'OMG',
		0.2,
		0.2,
		0.2,
		0.2,
		0.2,
		0.4,
		0.3,
		0.2,
		0.2,
		0.1,
		0.2,
		0.2,
		0.1,
		0.1,
		0.2,
		0.4,
		0.4,
		0.3,
		0.3,
		0.3,
		0.2,
		0.4,
		0.2,
		0.5,
		0.2,
		0.2,
		0.4,
		0.2,
		0.2,
		0.2,
		0.2,
		0.4,
		0.1,
		0.2,
		0.2,
		0.2,
		0.2,
		0.1,
		0.2,
		0.2,
		0.3,
		0.3,
		0.2,
		0.6,
		0.4,
		0.3,
		0.2,
		0.2,
		0.2,
		0.2
	];
	randomChart: any;

	ngOnInit(): void {
		this.hilfMir();
	}

	async ngAfterViewInit() {
		const colors = {
			primary: '#01a8fe',
			def: '#acb7bf',
			success: '#46be8a',
			danger: '#fb434a'
		};

		const scatter = c3.generate({
			bindto: '#scatter',
			data: {
				xs: {
					Danger: 'Danger_x',
					Primary: 'Primary_x'
				},
				columns: [
					[
						'Danger_x',
						3.5,
						3,
						3.2,
						3.1,
						3.6,
						3.9,
						3.4,
						3.4,
						2.9,
						3.1,
						3.7,
						3.4,
						3,
						3,
						4,
						4.2,
						3.9,
						3.5,
						3.8,
						3.8,
						3.4,
						3.7,
						3.6,
						3.3,
						3.4,
						3,
						3.4,
						3.5,
						3.4,
						3.2,
						3.1,
						3.4,
						4.1,
						4.2,
						3.1,
						3.2,
						3.5,
						3.6,
						3,
						3.4,
						3.5,
						2.3,
						3.2,
						3.5,
						3.8,
						3,
						3.8,
						3.2,
						3.7,
						3.3
					],
					[
						'Primary_x',
						3.2,
						3.2,
						3.1,
						2.3,
						2.8,
						2.8,
						3.3,
						2.4,
						2.9,
						2.7,
						2,
						3,
						2.2,
						2.9,
						2.9,
						3.1,
						3,
						2.7,
						2.2,
						2.5,
						3.2,
						2.8,
						2.5,
						2.8,
						2.9,
						3,
						2.8,
						3,
						2.9,
						2.6,
						2.4,
						2.4,
						2.7,
						2.7,
						3,
						3.4,
						3.1,
						2.3,
						3,
						2.5,
						2.6,
						3,
						2.6,
						2.3,
						2.7,
						3,
						2.9,
						2.9,
						2.5,
						2.8
					],
					[
						'Danger',
						0.2,
						0.2,
						0.2,
						0.2,
						0.2,
						0.4,
						0.3,
						0.2,
						0.2,
						0.1,
						0.2,
						0.2,
						0.1,
						0.1,
						0.2,
						0.4,
						0.4,
						0.3,
						0.3,
						0.3,
						0.2,
						0.4,
						0.2,
						0.5,
						0.2,
						0.2,
						0.4,
						0.2,
						0.2,
						0.2,
						0.2,
						0.4,
						0.1,
						0.2,
						0.2,
						0.2,
						0.2,
						0.1,
						0.2,
						0.2,
						0.3,
						0.3,
						0.2,
						0.6,
						0.4,
						0.3,
						0.2,
						0.2,
						0.2,
						0.2
					],
					[
						'Primary',
						1.4,
						1.5,
						1.5,
						1.3,
						1.5,
						1.3,
						1.6,
						1,
						1.3,
						1.4,
						1,
						1.5,
						1,
						1.4,
						1.3,
						1.4,
						1.5,
						1,
						1.5,
						1.1,
						1.6,
						1.3,
						1.5,
						1.2,
						1.3,
						1.4,
						1.4,
						1.2,
						1.5,
						1,
						1.1,
						1,
						1.2,
						1.6,
						1.5,
						1.6,
						1.5,
						1.3,
						1.3,
						1.3,
						1.2,
						1.4,
						1.2,
						1,
						1.3,
						1.2,
						1.3,
						1.3,
						1.1,
						1.3
					]
				],
				type: 'scatter'
			},
			color: {
				pattern: [colors.danger, colors.primary]
			},
			axis: {
				x: {
					label: 'Width',
					tick: {
						outer: !1,
						fit: !1
					}
				},
				size: {
					height: 400
				},
				padding: {
					right: 40
				},
				y: {
					label: 'Height',
					tick: {
						outer: !1,
						count: 5,
						values: [0, 0.4, 0.8, 1.2, 1.6]
					}
				}
			},
			grid: {
				x: {
					show: !1
				},
				y: {
					show: !0
				}
			}
		});
		const bar = c3.generate({
			bindto: '#bar',
			data: {
				columns: [
					['Danger', 30, 200, 100, 400, 150, 250],
					['Default', 130, 100, 140, 200, 150, 50],
					['Primary', 130, -150, 200, 300, -200, 100]
				],
				type: 'bar'
			},
			bar: {
				width: {
					max: 20
				}
			},
			color: {
				pattern: [colors.danger, colors.def, colors.primary]
			},
			grid: {
				y: {
					show: !0
				},
				x: {
					show: !1
				}
			}
		});

		const subChart = c3.generate({
			bindto: '#sub-chart',
			data: {
				columns: [
					[
						'Primary',
						100,
						165,
						140,
						270,
						200,
						140,
						220,
						210,
						190,
						100,
						170,
						250
					],
					['Success', 110, 80, 100, 85, 125, 90, 100, 130, 120, 90, 100, 115]
				],
				type: 'spline'
			},
			color: {
				pattern: [colors.primary, colors.danger]
			},
			subchart: {
				show: true
			}
		});
		this.randomChart = c3.generate({
			bindto: '#random',
			data: {
				xs: {
					OMG: 'OMG_x',
					Gut: 'Gut_x'
				},
				columns: [
					[
						'OMG_x',
						3.5,
						3,
						3.2,
						3.1,
						3.6,
						3.9,
						3.4,
						3.4,
						2.9,
						3.1,
						3.7,
						3.4,
						3,
						3,
						4,
						4.2,
						3.9,
						3.5,
						3.8,
						3.8,
						3.4,
						3.7,
						3.6,
						3.3,
						3.4,
						3,
						3.4,
						3.5,
						3.4,
						3.2,
						3.1,
						3.4,
						4.1,
						4.2,
						3.1,
						3.2,
						3.5,
						3.6,
						3,
						3.4,
						3.5,
						2.3,
						3.2,
						3.5,
						3.8,
						3,
						3.8,
						3.2,
						3.7,
						3.3
					],
					[
						'Gut_x',
						3.2,
						3.2,
						3.1,
						2.3,
						2.8,
						2.8,
						3.3,
						2.4,
						2.9,
						2.7,
						2,
						3,
						2.2,
						2.9,
						2.9,
						3.1,
						3,
						2.7,
						2.2,
						2.5,
						3.2,
						2.8,
						2.5,
						2.8,
						2.9,
						3,
						2.8,
						3,
						2.9,
						2.6,
						2.4,
						2.4,
						2.7,
						2.7,
						3,
						3.4,
						3.1,
						2.3,
						3,
						2.5,
						2.6,
						3,
						2.6,
						2.3,
						2.7,
						3,
						2.9,
						2.9,
						2.5,
						2.8
					],
					this.dataOMG,
					this.dataGut
				],
				type: 'scatter'
			},
			color: {
				pattern: [colors.danger, colors.primary]
			},
			axis: {
				x: {
					label: 'Width',
					tick: {
						outer: !1,
						fit: !1
					}
				},
				size: {
					height: 400
				},
				padding: {
					right: 40
				},
				y: {
					label: 'Height',
					tick: {
						outer: !1,
						count: 5,
						values: [0, 0.4, 0.8, 1.2, 1.6]
					}
				}
			},
			grid: {
				x: {
					show: !1
				},
				y: {
					show: !0
				}
			}
		});

		await new Promise(res => setTimeout(res, 1500));
		bar.flush();
		scatter.flush();
		subChart.flush();
		this.randomChart.flush();
	}

	currentPageDataChange(
		$event: Array<{
			name: string;
			age: number;
			address: string;
			checked: boolean;
			expand: boolean;
			description: string;
		}>
	): void {
		this.displayData = $event;
		this.refreshStatus();
	}

	refreshStatus(): void {
		const validData = this.displayData.filter(value => !value.disabled);
		const allChecked =
			validData.length > 0 && validData.every(value => value.checked === true);
		const allUnChecked = validData.every(value => !value.checked);
		this.allChecked = allChecked;
		this.indeterminate = !allChecked && !allUnChecked;
	}

	checkAll(value: boolean): void {
		this.displayData.forEach(data => {
			if (!data.disabled) {
				data.checked = value;
			}
		});
		this.refreshStatus();
	}

	noResultChange(status: boolean): void {
		this.listOfData = [];
		if (!status) {
			this.ngOnInit();
		}
	}

	omg() {
		this.listOfData.forEach(item => {
			item.name = 'Na klasse!';
			item.address = 'Kaputtgemacht!';
			item.age = null;
		});
		this.button3title = 'Hilf mir!';
	}

	hilfMir() {
		if (this.button3title != 'Button 3') {
			this.button3title = 'Button 3';
			this.listOfData = [];
			for (let i = 1; i <= 100; i++) {
				this.listOfData.push({
					name: 'John Brown',
					age: `${i}2`,
					address: `New York No. ${i} Lake Park`,
					description: `My name is John Brown, I am ${i}2 years old, living in New York No. ${i} Lake Park.`,
					checked: false,
					expand: false
				});
			}
		}
	}

	randomize() {
		this.randomChart.unload({ ids: ['Gut_x'] });
		for (let i = 1; i < this.dataOMG.length; i++) {
			const value = Math.floor(Math.random() * 100) / 100;
			this.dataOMG[i] = value;
			this.dataGut[i] = value + 1;
		}
		this.randomChart.load({ columns: [this.dataGut] });
		this.randomChart.unload({ ids: ['OMG_x'] });
		this.randomChart.load({ columns: [this.dataOMG] });
	}
}
